// removed by extract-text-webpack-plugin
module.exports = {"root":"ItemPerks--root--2I","perk":"ItemPerks--perk--1h","perkImage":"ItemPerks--perkImage--20","main":"ItemPerks--main--2w","name":"ItemPerks--name--1D","description":"ItemPerks--description--iu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemPerks/styles.styl
// module id = 847
// module chunks = 0